import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { TextField, Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useSnackbar } from '../context/SnackbarContext';
import { useTranslation } from 'react-i18next';

export default function ForgotPasswordForm({ callback = null, open, onClose }) {

    const { t } = useTranslation('common'); 

    const [email, setEmail] = React.useState("");

    const { showSnackbar } = useSnackbar();

    const [disableSubmit, setDisableSubmit] = useState(false);

    const handleSubmit = async () => {
        if (!email.trim()) {
          showSnackbar(t('messages.email_required'), "warning");
          return;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
          showSnackbar(t('users.messages.email_invalid'), "warning");
          return;
        }
        setDisableSubmit(true);
        onClose();
        callback(email);
    };

    const handleCancel = () => {
        setEmail("");   // clear field on cancel
        onClose();
    };

    React.useEffect(() => {
      if (open)
      {
        setEmail("");
        setDisableSubmit(false);
      }
    }, [open]);

    return (
        <>
        <Dialog onClose={handleCancel} open={open} disableRestoreFocus>

        <DialogTitle>{"Forgot Password"}</DialogTitle>

        <DialogContent dividers>
            <Stack spacing={1}>
              <Typography variant="body1" >Please enter your e-mail address</Typography>
              <TextField
                  autoFocus
                  label="E-mail Address"
                  variant="outlined"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  fullWidth
                  multiline
                  maxRows={1}
              />
            </Stack>
        </DialogContent>

        <DialogActions>
            <Button disabled={disableSubmit} onClick={handleSubmit}>
              Reset My Password
            </Button>
            <Button onClick={handleCancel}>Cancel</Button>
        </DialogActions>
        </Dialog>
        </>
    );
}